import { createSelector } from "@reduxjs/toolkit";
import { initialState, type PasswordResetState } from "./slice";

const passwordResetInitialState = (state: {
  passwordReset?: PasswordResetState;
}): PasswordResetState => state.passwordReset || initialState;

export const selectEmail = createSelector(
  [passwordResetInitialState],
  (state) => state.email,
);

export const selectRequestReset = createSelector(
  [passwordResetInitialState],
  (state) => state.requestReset,
);

export const selectVerifyOtp = createSelector(
  [passwordResetInitialState],
  (state) => state.verifyOtp,
);

export const selectResetPassword = createSelector(
  [passwordResetInitialState],
  (state) => state.resetPassword,
);
